export default class ScrollHeader {
    constructor(headerSelector) {
        this.lastScrollY = window.scrollY;
        this.header = document.querySelector(headerSelector);

        if (this.header) {
            this.init();
        }
    }

    init() {
        window.addEventListener('scroll', () => this.handleScroll());
    }

    handleScroll() {
        const scrollableHeight =
            document.documentElement.scrollHeight - window.innerHeight;

        if (window.scrollY === 0) {
            this.header.style.transform = 'translateY(0)';
            this.header.style.opacity = '100';
            this.header.style.visibility = 'visible';
        } else if (window.scrollY >= scrollableHeight) {
            this.header.style.transform = 'translateY(-20%)';
            this.header.style.opacity = '0';
            this.header.style.visibility = 'hidden';
        } else if (window.scrollY > this.lastScrollY) {
            this.header.style.transform = 'translateY(-20%)';
            this.header.style.opacity = '0';
            this.header.style.visibility = 'hidden';
        } else {
            this.header.style.transform = 'translateY(0)';
            this.header.style.opacity = '100';
            this.header.style.visibility = 'visible';
        }

        this.lastScrollY = window.scrollY;
    }
}